import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const RegVerify = () => {
    const { token } = useParams();
    const [message, setMessage] = useState("");
    const [show, setShow] = useState(false);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOST}/v1/auth/verifyReg?token=${token}`
                );
                const data = await response.json();
                setMessage(data?.message || "Aktivasi akun berhasil, silakan login!");
                setShow(true);
            } catch (error) {
                console.error("Error:", error);
                setMessage("Terjadi kesalahan. Silakan coba lagi.");
                setShow(true);
            }
        }
        fetchData();
    }, [token]);

    return (
        <>
            {show && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full text-center">
                        <p className="text-gray-800">{message}</p>
                        <button
                            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                            onClick={() => setShow(false)}
                        >
                            Tutup
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default RegVerify;
